import { LinearProgress } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import CalculationNotExist from "./CalculationNotExist";
import CalculationResultTable from "./CalculationResultTable";
import { extractCalculationData } from "./calculationResultUtils";
import {
  useCalculationOutputData,
  useQueryCalculationSchema
} from "./hooks/calculationResultHooks";

const useStyles = makeStyles(theme => ({
  darkBackgroundColor: {
    backgroundColor: theme.palette.primary.dark
  },
  margin: {
    marginBottom: theme.spacing(1)
  }
}));

interface CalculationResultOutputTableProps {
  useCaseKey: string;
  useCaseVersion: string;
  calculationId: string;
  tableId: string;
}
const CalculationResultOutputTable = ({
  useCaseKey,
  useCaseVersion,
  calculationId,
  tableId: name
}: CalculationResultOutputTableProps) => {
  const { darkBackgroundColor, margin } = useStyles();
  const { loadOutputData } = useCalculationOutputData();
  const { data, error, loading } = useQueryCalculationSchema({
    useCaseKey,
    useCaseVersion,
    calculationId
  });

  const calculation = data?.cloudPlatform.useCases?.[0]?.calculation;

  if (loading) return <LinearProgress className={margin} />;
  if (!calculation) {
    return <CalculationNotExist />;
  }
  const { outputColumnDefs } = extractCalculationData(calculation);
  return (
    <CalculationResultTable
      columnDefs={outputColumnDefs}
      name={name}
      useCaseKey={useCaseKey}
      useCaseVersion={useCaseVersion}
      calculationId={calculationId}
      loadData={loadOutputData}
      backgroundColor={darkBackgroundColor}
      loading={loading}
      error={error}
    />
  );
};
export default CalculationResultOutputTable;
